import 'es6-promise/auto'

Object.assign = require('object-assign')



// WEBPACK FOOTER //
// ./~/ream/app/polyfills.js